// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M5.5 10.5L13.5 16L21.5 10.5M5 10H22V11V22H5V11V10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"mark-as-unread"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5 10H22V22H5V10Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.5 10.5L13.5 16L21.5 10.5M5 10H22V11V22H5V11V10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M1 19V8.5V7.5L9.5 2.5L13.75 5L15.875 6.25","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MarkAsUnreadIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mark-as-unread',
    ref,
    icon: element,
  },
));

MarkAsUnreadIcon.displayName = 'MarkAsUnreadIcon';

export default MarkAsUnreadIcon;
